import React from 'react'

import { Link } from 'gatsby'

const year = new Date().getFullYear()

class Footer extends React.Component {
  render() {
    return (
      <footer className="dib relative w-100 bg-white pv5 fw5 z-2 lh-copy footer">
        <div className="center mw9 ph3 ph5-ns pv0 tl">
          <div className="row top-xs">
            <div className="col-xs-12 col-md-8">
              <div className="dib relative w-100">
                <a
                  href="mailto:merchantsupport@paytm.ca"
                  className="link b f4 f3-ns dim navy"
                >
                  merchantsupport@paytm.ca
                </a>
                <p className="f6 db ttu mb4">&copy; {year} Paytm Labs</p>
                <a
                  href="https://goo.gl/maps/gPCLTe46QYQ2"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dib relative w-auto dark-gray link dim f6"
                >
                  1 Richmond Street West, Suite 200 • Toronto, ON M5H 3W4
                </a>
              </div>

              <div className="dib relative w-100 mv4 measure-wide links">
                <a
                  href="https://twitter.com/paytmcanada"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Twitter"
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                >
                  Twitter
                </a>
                <a
                  href="https://www.linkedin.com/company/paytm-labs/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="LinkedIn"
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                >
                  LinkedIn
                </a>
                <a
                  href="https://www.instagram.com/paytm_canada/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Instagram"
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                >
                  Instagram
                </a>
                <a
                  href="https://jobs.lever.co/paytm?location=Toronto"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Careers"
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                >
                  Careers
                </a>
                <a
                  href="https://care.paytm.ca/"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Support"
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                >
                  Support
                </a>
              </div>
            </div>

            <div className="col-xs-12 col-md-4">
              <div className="dib relative w-100 measure-wide links">
                <Link
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                  target="_blank"
                  title="Terms of Use"
                  rel="noopener noreferrer"
                  to="terms-of-use"
                >
                  Terms of Use
                </Link>
                <Link
                  className="link dim f6 dib w-100 w-auto-ns dark-gray pa2"
                  target="_blank"
                  title="Privacy Policy"
                  rel="noopener noreferrer"
                  to="privacy-policy"
                >
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
